import { render, staticRenderFns } from "./PqrsExternos.vue?vue&type=template&id=4809f6f6&scoped=true"
import script from "./PqrsExternos.vue?vue&type=script&lang=js"
export * from "./PqrsExternos.vue?vue&type=script&lang=js"
import style0 from "./PqrsExternos.vue?vue&type=style&index=0&id=4809f6f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4809f6f6",
  null
  
)

export default component.exports